import * as Yup from "yup";

export const UpdatePasswordSchema = Yup.object().shape({
  senhaAtual: Yup.string().required("Senha antiga não pode ser vazia"),
  senhaNova: Yup.string().min(6, "A senha deve conter no mínimo 6 caracteres").required("Senha nova não pode ser vazia"),
  confirmacaoSenhaNova: Yup.string()
    .required("Confirmar senha não pode ser vazio")
    .oneOf(
      [Yup.ref("senhaNova"), null],
      "A senha nova e confirmação de senha estão diferentes"
    )
});
